import * as map_helpers from '../components/app/map/Map_helpers';
import * as fetch_helpers from './Fetch_helpers';
import * as turf from '@turf/turf';
import ColorThief from 'colorthief';
import Papa from 'papaparse';

//__________ UI

export const get_pretty_num = (num, nb_decimals) => {

    if (num === null || num === undefined || isNaN(num)) {
        return "";
    }

    // Get string from num
    var num_string = num.toString();
    if (nb_decimals) {
        num_string = (num.toFixed(nb_decimals)).toString();
    }

    // Get . posiiton
    var separation = num_string.indexOf('.');

    // Get parts
    var num_string_first = num_string;
    var num_string_second = "";
    if (separation >= 0) {
        num_string_first = num_string.substring(0, separation);
        num_string_second = num_string.substring(separation + 1, num_string.length);
    }

    // Add space to first part
    var num_string_first_reverse = num_string_first.split("").reverse().join("");
    var num_string_first_reverse_spaced = num_string_first_reverse.match(/.{1,3}/g).join(" ");
    var num_string_first_spaced = num_string_first_reverse_spaced.split("").reverse().join("");

    // Create final
    var num_string_final = num_string_first_spaced;
    if (num_string_second !== "") {
        num_string_final = num_string_final + "," + num_string_second;
    }

    return num_string_final;
}

export const get_pretty_date_dd_mm_yyyy_from_yyy_mm_dd = (date_yyy_mm_dd) => {
    var elements = date_yyy_mm_dd.split("-");
    elements.reverse();
    return elements.join("/")
}


//__________ COMBINATIONS

export const m_combinations = (permutation) => {
    var length = permutation.length,
        result = [permutation.slice()],
        c = new Array(length).fill(0),
        i = 1, k, p;

    while (i < length) {
        if (c[i] < i) {
            k = i % 2 && c[i];
            p = permutation[i];
            permutation[i] = permutation[k];
            permutation[k] = p;
            ++c[i];
            i = 1;
            result.push(permutation.slice());
        } else {
            c[i] = 0;
            ++i;
        }
    }
    return result;
}

export const l_combinations = (array) => {
    const res = [];
    let max = array.length - 1;
    const helper = (arr, i) => {
        for (let j = 0, l = array[i].length; j < l; j++) {
            let copy = arr.slice(0);
            copy.push(array[i][j]);
            if (i == max)
                res.push(copy);
            else
                helper(copy, i + 1);
        };
    };
    helper([], 0);
    return res;
};

export const k_combinations = (set, k) => {
    var i, j, combs, head, tailcombs;

    // There is no way to take e.g. sets of 5 elements from
    // a set of 4.
    if (k > set.length || k <= 0) {
        return [];
    }

    // K-sized set has only one K-sized subset.
    if (k === set.length) {
        return [set];
    }

    // There is N 1-sized subsets in a N-sized set.
    if (k === 1) {
        combs = [];
        for (i = 0; i < set.length; i++) {
            combs.push([set[i]]);
        }
        return combs;
    }

    // Assert {1 < k < set.length}

    // Algorithm description:
    // To get k-combinations of a set, we want to join each element
    // with all (k-1)-combinations of the other elements. The set of
    // these k-sized sets would be the desired result. However, as we
    // represent sets with lists, we need to take duplicates into
    // account. To avoid producing duplicates and also unnecessary
    // computing, we use the following approach: each element i
    // divides the list into three: the preceding elements, the
    // current element i, and the subsequent elements. For the first
    // element, the list of preceding elements is empty. For element i,
    // we compute the (k-1)-computations of the subsequent elements,
    // join each with the element i, and store the joined to the set of
    // computed k-combinations. We do not need to take the preceding
    // elements into account, because they have already been the i:th
    // element so they are already computed and stored. When the length
    // of the subsequent list drops below (k-1), we cannot find any
    // (k-1)-combs, hence the upper limit for the iteration:
    combs = [];
    for (i = 0; i < set.length - k + 1; i++) {
        // head is a list that includes only our current element.
        head = set.slice(i, i + 1);
        // We take smaller combinations from the subsequent elements
        tailcombs = k_combinations(set.slice(i + 1), k - 1);
        // For each (k-1)-combination we join it with the current
        // and store it to the set of k-combinations.
        for (j = 0; j < tailcombs.length; j++) {
            combs.push(head.concat(tailcombs[j]));
        }
    }
    return combs;
}


// SVG COORDINATES

export const get_svgCoords_from_boundsGroupsList = (bounds_groups, bbox) => {
    // console.log("SVG FROM BOUNDS GROUPS", bounds_groups, bbox);

    // Create local coords list
    var localCoords = [];
    bounds_groups.forEach(bounds_group => {
        if (bounds_group?.start_coord_local) {
            localCoords.push(bounds_group.start_coord_local);
        }
    })
    // console.log("localCoords", localCoords);

    var svgCoords = get_svgCoords_from_localCoords(localCoords, bbox);
    // console.log("svgCoords", svgCoords);

    return svgCoords
    // return [[0, 0], [100, 0], [100, 100], [0, 200]]

}

export const get_svgCoords_from_globalCoords = (globalCoords, bbox) => {
    // console.log("SVG FROM GLOBAL COORDS", globalCoords, bbox);

    var svgCoords = [];

    try {
        for (var i = 0; i < globalCoords.length; i++) {

            var globalCoords_i = globalCoords[i];
            // First is the outerline
            if (i > 0) {
                globalCoords_i = globalCoords[i].reverse();
            }

            // Get local coords
            var localCoords = [];
            globalCoords_i.forEach(globalCoord => {
                localCoords.push(map_helpers.mercator_to_local(globalCoord, bbox.origin));
            })
            // console.log(localCoords);

            // Get svg coords
            svgCoords = svgCoords.concat(get_svgCoords_from_localCoords(localCoords, bbox));
            // console.log(svgCoords);
        }
        return svgCoords

    } catch (error) {
        console.log("ERROR CREATING SVG", error);
        return svgCoords
    }

    // return [[0, 0], [100, 0], [100, 100], [0, 200]]

}

export const get_svgCoords_from_localCoords = (localCoords, bbox) => {
    // console.log("SVG FROM LOCAL COORDS", localCoords, bbox);


    // Get svg coords
    var svgWidth = 800;
    var svgCoords = [];

    localCoords.forEach(localCoord => {
        if (bbox.lengthH >= bbox.lengthV) {
            var scaleFactor = svgWidth / bbox.lengthH;
            var verticalOffset = (svgWidth - (bbox.lengthV * scaleFactor)) / 2;
            svgCoords.push([localCoord[0] * scaleFactor, svgWidth - (localCoord[1] * scaleFactor) - verticalOffset]);
        }
        else {
            var scaleFactor = svgWidth / bbox.lengthV;
            var horizontalOffset = (svgWidth - (bbox.lengthH * scaleFactor)) / 2;
            svgCoords.push([(localCoord[0] * scaleFactor) + horizontalOffset, svgWidth - (localCoord[1] * scaleFactor)]);
        }
    });

    return svgCoords
}

export const get_svgPath_from_svgCoords = (svgCoords, isHole) => {

    var svgPath = "";

    // Remove last item because it's the same as first one but in svg it auto close
    svgCoords.pop();

    // Reverse array if hole
    if (isHole === true) {
        svgCoords.reverse();
    }

    svgCoords.forEach((svgCoord, index) => {
        var type = " L";
        if (index === 0) { type = "M" }

        svgPath = svgPath + type + " " + svgCoord[0].toFixed(2) + " " + svgCoord[1].toFixed(2);

        if (index === svgCoords.length - 1) { svgPath = svgPath + " Z" }
    });

    return svgPath
}


// COMPRESS AND OPTIMIZE CAPA
export const compressCapa = (capa) => {

    // console.log("-SAVING CAPA- : Optimizing");

    // Create new capa optimized
    var capaOptim = JSON.parse(JSON.stringify(capa));
    // console.log(capaOptim);

    // Opitimizing specific parts

    // LANDBASE > UNION > BOUNDS GROUPS > CONTEXT ANALYSIS > LANDS & ROADS
    if (capaOptim?.landBase?.union?.bounds_groups) {
        for (var i = 0; i < capaOptim.landBase.union.bounds_groups.length; i++) {
            if (capaOptim.landBase.union.bounds_groups[i]?.context_analysis?.lands) {
                for (var j = 0; j < capaOptim.landBase.union.bounds_groups[i].context_analysis.lands.length; j++) {
                    // Reduce data
                    if (capaOptim?.landBase?.union?.bounds_groups[i]?.context_analysis?.lands[j]?.data?.properties?.section) {
                        capaOptim.landBase.union.bounds_groups[i].context_analysis.lands[j].data = { id: capaOptim.landBase.union.bounds_groups[i].context_analysis.lands[j].data.id, name: capaOptim.landBase.union.bounds_groups[i].context_analysis.lands[j].data.properties.section + "-" + capaOptim.landBase.union.bounds_groups[i].context_analysis.lands[j].data.properties.numero }
                    }
                    // Erase point and line and check_line
                    delete capaOptim.landBase.union.bounds_groups[i].context_analysis.lands[j].point;
                    delete capaOptim.landBase.union.bounds_groups[i].context_analysis.lands[j].line;
                    delete capaOptim.landBase.union.bounds_groups[i].context_analysis.lands[j].check_line;
                }
            }
            if (capaOptim.landBase.union.bounds_groups[i]?.context_analysis?.roads) {
                for (var j = 0; j < capaOptim.landBase.union.bounds_groups[i].context_analysis.roads.length; j++) {
                    // Reduce data
                    if (capaOptim.landBase.union.bounds_groups[i].context_analysis.roads[j]?.data?.properties?.name) {
                        capaOptim.landBase.union.bounds_groups[i].context_analysis.roads[j].data = { id: capaOptim.landBase.union.bounds_groups[i].context_analysis.roads[j].data.id, name: capaOptim.landBase.union.bounds_groups[i].context_analysis.roads[j]?.data?.properties?.name || "Route non nommée" }
                    }
                    // Erase point and line and check_line
                    delete capaOptim.landBase.union.bounds_groups[i].context_analysis.roads[j].point;
                    delete capaOptim.landBase.union.bounds_groups[i].context_analysis.roads[j].line;
                    delete capaOptim.landBase.union.bounds_groups[i].context_analysis.roads[j].check_line;
                }
            }
        }
    }

    // LANDBASE > TOPO > MATRIX
    // if (capaOptim?.landBase?.topo?.matrix && capaOptim?.landBase?.topo?.matrix.length > 0 && capaOptim.landBase.topo.matrix[0].coord_global) {
    //     for (var i = 0; i < capaOptim.landBase.topo.matrix.length; i++) {
    //         capaOptim.landBase.topo.matrix[i] = {
    //             cg: capaOptim.landBase.topo.matrix[i].coord_global,
    //             cl: capaOptim.landBase.topo.matrix[i].coord_local,
    //             z: capaOptim.landBase.topo.matrix[i].elevation,
    //         }
    //     }
    // }

    // LANDBASE > BUILDINGS
    if (capaOptim?.landBase?.buildings?.buildings && capaOptim?.landBase?.buildings?.buildings_land) {
        for (var i = 0; i < capaOptim.landBase.buildings.buildings.length; i++) {
            if (!capaOptim.landBase.buildings.buildings_land.includes(i)) {
                capaOptim.landBase.buildings.buildings[i].properties = {
                    id: capaOptim.landBase.buildings.buildings[i].properties.id,
                    area: capaOptim.landBase.buildings.buildings[i].properties.area,
                    height_max: capaOptim.landBase.buildings.buildings[i].properties.height_max,
                }
            }
        }
    }

    // CONTEXT > DVF > DVF_TRASACTIONS
    // if (capaOptim?.context?.dvf?.dvf_transactions && capaOptim?.context?.dvf?.dvf_transactions_land) {
    //     var dvf_transactions_optim = {};
    //     for (var i = 0; i < capaOptim.context.dvf.dvf_transactions_land.length; i++) {
    //         dvf_transactions_optim[capaOptim.context.dvf.dvf_transactions_land[i]] = capaOptim.context.dvf.dvf_transactions[capaOptim.context.dvf.dvf_transactions_land[i]];
    //     }
    //     capaOptim.context.dvf.dvf_transactions = dvf_transactions_optim;
    // }


    // RULES > GPU_DATA > DOCUMENT
    if (capaOptim?.rules?.gpu_data?.document) {
        var document_optim = {
            id: capaOptim.rules.gpu_data.document.id,
            id_list: capaOptim.rules.gpu_data.document?.id_list || [capaOptim.rules.gpu_data.document.id],
            title: capaOptim.rules.gpu_data.document.title,
            originalName: capaOptim.rules.gpu_data.document.originalName,
            archiveUrl: capaOptim.rules.gpu_data.document.archiveUrl,
        };
        if (capaOptim.rules.gpu_data.document?.id_model) {
            document_optim.id_model = capaOptim.rules.gpu_data.document.id_model;
        }
        capaOptim.rules.gpu_data.document = document_optim;
    }

    // RULES > GPU_DATA > FILES
    if (capaOptim?.rules?.gpu_data?.files) {
        for (var file_group of Object.keys(capaOptim.rules.gpu_data.files)) {
            for (var i = 0; i < capaOptim.rules.gpu_data.files[file_group].length; i++) {
                delete capaOptim.rules.gpu_data.files[file_group][i].label;
                delete capaOptim.rules.gpu_data.files[file_group][i].name;
                delete capaOptim.rules.gpu_data.files[file_group][i].path;
            }
        }
    }

    // RULES > RULESET > ITEM > INTERPRETED
    var rules = { ...capaOptim.rules };
    rules.ruleset.forEach(ruleset => {
        ruleset.items.forEach(item => {
            if (item.type === "rule") {
                item.interpreted = ["removed"]
            }
        })
    })
    capaOptim.rules = rules;

    // BUILDABLE > VOLUME
    capaOptim.buildable.volume.interpreted = ["removed"];

    // BUILDABLE > COMBINATIONS
    capaOptim.buildable.combinations = ["removed"];


    // OPTMIZATION STATISTICS
    var size_origin = JSON.stringify(capa).length;
    var size_optim = JSON.stringify(capaOptim).length;
    // console.log("FULL ORIGINAL size :", size_origin, " (" + (size_origin / 1024 / 1024).toFixed(1) + " Mb)");
    // console.log("FULL OPTIMIZED size :", size_optim, " (" + (size_optim / 1024 / 1024).toFixed(1) + " Mb)");
    // console.log("Optimization :", size_origin - size_optim, " (-" + (100 * (size_origin - size_optim) / size_origin).toFixed(2) + "%)");


    // KEEP ONLY UPDATED PARTS
    if (capaOptim?.toSave?.keys && capaOptim?.toSave?.keys.length > 0 && !capaOptim?.toSave?.keys.includes("all")) {
        var capaOptimPartial = {
            _id: capaOptim._id,
            __v: capaOptim.__v,
            toSave: capaOptim.toSave,
            modifications: capaOptim.modifications,
            simplified: capaOptim?.simplified || {},
        }
        var keysSetted = [...new Set(capaOptim.toSave.keys)];
        var keysFiltered = [];
        // Add full keys
        var keyFull = [];
        for (var i = 0; i < keysSetted.length; i++) {
            if (!keysSetted[i].includes("__") && !keyFull.includes(keysSetted[i])) {
                capaOptimPartial[keysSetted[i]] = capaOptim[keysSetted[i]];
                keyFull.push(keysSetted[i]);
                keysFiltered.push(keysSetted[i]);
            }
        }
        // Add partial keys
        for (var i = 0; i < keysSetted.length; i++) {
            if (!keyFull.includes(keysSetted[i]) && keysSetted[i].includes("__") && !keyFull.includes(keysSetted[i].split("__")[0])) {
                // var test = getPartialCapa(capa, keysSetted[i]);
                keysFiltered.push(keysSetted[i]);
                var keySetted_list = keysSetted[i].split("__");
                console.log("deep key", keysSetted[i], keySetted_list);
                var current_item = null;
                var target_item = capaOptim;
                for (var j = 0; j < keySetted_list.length; j++) {
                    // Check if key exists in source
                    if (!Object.keys(target_item).includes(keySetted_list[j])) {
                        break;
                    }
                    // Set current and target item
                    if (j === 0) {
                        current_item = capaOptimPartial;
                        target_item = capaOptim[keySetted_list[0]];
                    }
                    else if (j === 1) {
                        current_item = capaOptimPartial[keySetted_list[0]];
                        target_item = capaOptim[keySetted_list[0]][keySetted_list[1]];
                    }
                    else if (j === 2) {
                        current_item = capaOptimPartial[keySetted_list[0]][keySetted_list[1]];
                        target_item = capaOptim[keySetted_list[0]][keySetted_list[1]][keySetted_list[2]];
                    }
                    else if (j === 3) {
                        current_item = capaOptimPartial[keySetted_list[0]][keySetted_list[1]][keySetted_list[2]];
                        target_item = capaOptim[keySetted_list[0]][keySetted_list[1]][keySetted_list[2]][keySetted_list[3]];
                    }
                    else if (j === 4) {
                        current_item = capaOptimPartial[keySetted_list[0]][keySetted_list[1]][keySetted_list[2]][keySetted_list[3]];
                        target_item = capaOptim[keySetted_list[0]][keySetted_list[1]][keySetted_list[2]][keySetted_list[3]][keySetted_list[4]];
                    }
                    else if (j === 5) {
                        current_item = capaOptimPartial[keySetted_list[0]][keySetted_list[1]][keySetted_list[2]][keySetted_list[3]][keySetted_list[4]];
                        target_item = capaOptim[keySetted_list[0]][keySetted_list[1]][keySetted_list[2]][keySetted_list[3]][keySetted_list[4]][keySetted_list[5]];
                    }
                    else if (j === 6) {
                        current_item = capaOptimPartial[keySetted_list[0]][keySetted_list[1]][keySetted_list[2]][keySetted_list[3]][keySetted_list[4]][keySetted_list[5]];
                        target_item = capaOptim[keySetted_list[0]][keySetted_list[1]][keySetted_list[2]][keySetted_list[3]][keySetted_list[4]][keySetted_list[5]][keySetted_list[6]];
                    }
                    else if (j === 7) {
                        current_item = capaOptimPartial[keySetted_list[0]][keySetted_list[1]][keySetted_list[2]][keySetted_list[3]][keySetted_list[4]][keySetted_list[5]][keySetted_list[6]];
                        target_item = capaOptim[keySetted_list[0]][keySetted_list[1]][keySetted_list[2]][keySetted_list[3]][keySetted_list[4]][keySetted_list[5]][keySetted_list[6]][keySetted_list[7]];
                    }
                    else if (j === 8) {
                        current_item = capaOptimPartial[keySetted_list[0]][keySetted_list[1]][keySetted_list[2]][keySetted_list[3]][keySetted_list[4]][keySetted_list[5]][keySetted_list[6]][keySetted_list[7]];
                        target_item = capaOptim[keySetted_list[0]][keySetted_list[1]][keySetted_list[2]][keySetted_list[3]][keySetted_list[4]][keySetted_list[5]][keySetted_list[6]][keySetted_list[7]][keySetted_list[8]];
                    }
                    else if (j === 9) {
                        current_item = capaOptimPartial[keySetted_list[0]][keySetted_list[1]][keySetted_list[2]][keySetted_list[3]][keySetted_list[4]][keySetted_list[5]][keySetted_list[6]][keySetted_list[7]][keySetted_list[8]];
                        target_item = capaOptim[keySetted_list[0]][keySetted_list[1]][keySetted_list[2]][keySetted_list[3]][keySetted_list[4]][keySetted_list[5]][keySetted_list[6]][keySetted_list[7]][keySetted_list[8]][keySetted_list[9]];
                    }
                    // Check if key exists in target
                    if (!Object.keys(current_item).includes(keySetted_list[j])) {
                        current_item[keySetted_list[j]] = {};
                    }
                    // Add data
                    if (j === keySetted_list.length - 1) {
                        current_item[keySetted_list[j]] = target_item;
                    }
                }
            }
        }
        // Set keys filtered
        capaOptimPartial.toSave.keys = keysFiltered;
        console.log("-SAVING CAPA- : Partialized", capaOptimPartial?.toSave?.keys, capaOptimPartial);
        // console.log("-SAVING CAPA- : Optimized & Trimmed");
        var size_trim = JSON.stringify(capaOptimPartial).length;
        console.table({
            "original": size_origin + " (" + (size_origin / 1024 / 1024).toFixed(1) + " Mb)",
            "optimized": size_optim + " (" + (size_optim / 1024 / 1024).toFixed(1) + " Mb)",
            "result optim": (size_origin - size_optim) + " (" + (100 * (size_origin - size_optim) / size_origin).toFixed(2) + "%)",
            "trimmed": size_trim + " (" + (size_trim / 1024 / 1024).toFixed(1) + " Mb)",
            "result trim": (size_origin - size_trim) + " (" + (100 * (size_origin - size_trim) / size_origin).toFixed(2) + "%)",
        })

        return capaOptimPartial
        // return capaOptim
    }

    console.log("-SAVING CAPA- : Optimized");
    console.table({
        "original": size_origin + " (" + (size_origin / 1024 / 1024).toFixed(1) + " Mb)",
        "optimized": size_optim + " (" + (size_optim / 1024 / 1024).toFixed(1) + " Mb)",
        "result": (size_origin - size_optim) + " (" + (100 * (size_origin - size_optim) / size_origin).toFixed(2) + "%)",
    })

    return capaOptim
}

// const getPartialCapa = (capa, keyValue) => {
//     var keySetted_list = keyValue.split("__");
//     console.log("[TEST] deep key", keyValue, keySetted_list);
//     var tree = JSON.parse(JSON.stringify(capa));
//     var branch = JSON.parse(JSON.stringify(capa));
//     for (var i = 0; i < keySetted_list.length; i++) {
//         var current_key = keySetted_list[j];
//         var branch_keys = Object.keys(branch);
//         // Check if key exists in source
//         if (!branch_keys.includes(current_key)) {
//             break;
//         }
//         // Delete other keys
//         branch_keys.forEach(branch_key => {
//             if (branch_key !== current_key) {

//             }
//         })
//     }
// }


// _________ COLORS

// export const getColorMain2 = async (imgData) => {
//     const fac = new FastAverageColor();
//     const res = await fac.getColorAsync(imgData);
//     return res?.hex || "#062134"
// }
export const getColorMain = async (imgData) => {
    return new Promise((resolve, reject) => {
        var image = new Image();
        image.onload = () => resolve(extractColor(image))
        image.onerror = reject;
        image.src = imgData;
    })
}
function extractColor(image) {
    const colorThief = new ColorThief();
    try {
        var rgb = colorThief.getColor(image);
        return rgbToHex(rgb[0], rgb[1], rgb[2])
    } catch (error) {
        console.log(error);
        return "#062134";
    }
}
const rgbToHex = (r, g, b) => '#' + [r, g, b].map(x => {
    const hex = x.toString(16)
    return hex.length === 1 ? '0' + hex : hex
}).join('')
export function getColorContrast(color) {
    return (luma(color) >= 165) ? '#000' : '#FFF';
}
function luma(color) // color can be a hx string or an array of RGB values 0-255
{
    var rgb = (typeof color === 'string') ? hexToRGBArray(color) : color;
    return (0.2126 * rgb[0]) + (0.7152 * rgb[1]) + (0.0722 * rgb[2]); // SMPTE C, Rec. 709 weightings
}
function hexToRGBArray(color) {
    if (color.length === 3)
        color = color.charAt(0) + color.charAt(0) + color.charAt(1) + color.charAt(1) + color.charAt(2) + color.charAt(2);
    else if (color.length === 7) {
        color = color.substring(1);
    }
    else if (color.length !== 6)
        throw ('Invalid hex color: ' + color);
    var rgb = [];
    for (var i = 0; i <= 2; i++)
        rgb[i] = parseInt(color.substr(i * 2, 2), 16);
    return rgb;
}


// UPDATE MODEL

export const update_capa_model = (capacity) => {
    var updatedKeys = [];

    // __________ UPDATES
    // TEST
    if (capacity?.buildable?.volume?.parameters && !capacity?.buildable?.volume?.parameters?.test_04) {
        capacity.buildable.volume.parameters.test_04 = "OK";
        updatedKeys.push("buildable");
    }
    // Coef Area to SHAB
    if (capacity?.buildable?.volume?.parameters && !capacity?.buildable?.volume?.parameters?.coef_area_to_shabsu) {
        capacity.buildable.volume.parameters.coef_area_to_shabsu = 0.7;
        updatedKeys.push("buildable");
    }
    // Remove landBase > buildings_osm
    // if (capacity?.landBase?.buildings_osm && capacity?.landBase?.buildings_osm) {
    //     capacity.buildable.volume.parameters.coef_area_to_shabsu = 0.7;
    //     updatedKeys.push("buildable");
    // }

    // __________ SAVE
    // Update save parameters
    if (updatedKeys.length > 0) {
        capacity.toSave.keys = updatedKeys;
        capacity.toSave.autoSave = true;
        console.log("-FETCHING CAPA- : Updated Model");
    }

    return capacity
}


// BUILDINGS
export const get_existing_buildings_bound_type = (capacity) => {
    try {
        if (capacity?.landBase?.buildings?.buildings && capacity?.landBase?.buildings?.buildings_land && capacity?.landBase?.buildings?.buildings_land.length > 0) {
            var new_buildings = JSON.parse(JSON.stringify(capacity.landBase.buildings.buildings));

            capacity.landBase.buildings.buildings_land.forEach(building_index => {
                new_buildings[building_index].properties.bounds_type = [];
                var building_coords = new_buildings[building_index].geometry.coordinates[0];
                for (var i = 1; i < building_coords.length; i++) {
                    // ANALYSIS TO CREATE
                    new_buildings[building_index].properties.bounds_type.push(
                        {
                            isMit: false,
                            mit_i: null,
                            mit_distance: 0,
                            mit_land: false,
                        }
                    )
                }
                // delete new_buildings[building_index].properties.bounds_type;
            })

            return new_buildings;
        }
        return null
    } catch (error) {
        console.log("ERROR - get_existing_buildings_bound_type");
        return null
    }
}




// BDNB DATA BASE CSV

const bdnb_get_geometry_from_string = (geom_string) => {
    var geom_result = null;

    try {
        if (geom_string.includes("MULTIPOLYGON")) {
            geom_string = geom_string.substring(13);
            geom_string = geom_string.split("(").join("[");
            geom_string = geom_string.split(")").join("]");
            geom_string = geom_string.split(",").join("],[");
            geom_string = geom_string.split(" ").join(",");
            geom_string = "[" + geom_string + "]";
            var geom_json = JSON.parse(geom_string);
            var geom_wgs84 = [];
            geom_json.forEach((json_1, json_1_index) => {
                geom_wgs84.push([]);
                json_1.forEach((json_2, json_2_index) => {
                    geom_wgs84[json_1_index].push([]);
                    json_2.forEach((json_3) => {
                        geom_wgs84[json_1_index][json_2_index].push(fetch_helpers.get_wgs84_from_lambert(json_3));
                    })
                })
            })
            // console.log(geom_wgs84.length, geom_wgs84[0].length, geom_wgs84[0][0].length);
            var geaom_turf = turf.multiPolygon(geom_wgs84);
            return geaom_turf
        }
        else {
            console.log("OTHER TYPE", geom_string);
        }
    } catch (error) {
        console.log(error);
        console.log(geom_string);
        return geom_result
    }

    return geom_result
}

export const try_CSV_parsing2 = async () => {
    // var geom = "MULTIPOLYGON (((325629.4 6792731.5,325631.0 6792726.1,325626.6 6792726.0,325627.0 6792730.6,325629.4 6792731.5)))";
    // var geometry = bdnb_get_geometry_from_string(geom);
    // console.log(geometry);
    console.log("|| CREATING BDNB DATABASE ||");
    console.log("--> Import : batiment_groupe.csv");
}

const download_json_file = (json_data, file_name) => {
    const json_txt = JSON.stringify(json_data);
    const name = file_name + ".json";
    const type = "text/plain";
    const a = document.createElement("a");
    const file = new Blob([json_txt], { type: type });
    a.href = URL.createObjectURL(file);
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
}

var data_parcelle = {};
var data_commune = {};
var data_filtre = {};
var data_batiment = {};

var commune_list = [];
var nb_parcelle = 0;
var bat_list_h1 = [];
var nb_bat = 0;

export const download_file_parcelles = () => {
    download_json_file(data_parcelle, "parcelles_list");
    download_json_file(data_commune, "communes_list");
    download_json_file(data_filtre, "filtres_list");
}

export const try_CSV_parsing = async (file) => {
    if (file?.name === "parcelle.csv" || file?.name === "parcelle_simple.csv") {
        console.log("PARSE PARCELLE.csv ...");

        data_parcelle = {};
        data_commune = {};
        data_filtre = {};
        commune_list = [];

        var count = 0;
        Papa.parse(file, {
            step: function (row) {
                // console.log("Row:", row);
                if (count > 0 && row.data.length > 1) {
                    // Commune
                    if (!commune_list.includes(row.data[3])) {
                        commune_list.push(row.data[3]);
                        data_parcelle[row.data[3]] = {};
                        data_commune[row.data[3]] = { sections: {} };
                        data_filtre[row.data[3]] = {};
                    }
                    // Arrond
                    var arrond = row.data[1].substring(5, 8);
                    if (!Object.keys(data_parcelle[row.data[3]]).includes(arrond)) {
                        data_parcelle[row.data[3]][arrond] = {};
                    }
                    // Section
                    var section = row.data[1].substring(8, 10);
                    if (!Object.keys(data_parcelle[row.data[3]][arrond]).includes(section)) {
                        data_parcelle[row.data[3]][arrond][section] = [];
                    }
                    if (!Object.keys(data_commune[row.data[3]].sections).includes(section)) {
                        data_commune[row.data[3]].sections[section] = { lands: [], bbox: [], near: [] };
                    }
                    // Add data parcelles
                    // var num = row.data[1].substring(10);
                    var geom = bdnb_get_geometry_from_string(row.data[0]);
                    var superficie = geom ? Math.round(turf.area(geom)) : null;
                    var perimetre = geom ? Math.round(turf.length(turf.polygonToLine(geom)) * 1000) : null;
                    // var centerOfMass = geom ? turf.getCoord(turf.centroid(geom)) : null;
                    var bbox = geom ? turf.bbox(geom) : null;
                    var bbox_optim = null;
                    if (bbox) {
                        bbox_optim = [];
                        bbox.forEach(coord => {
                            bbox_optim.push(parseFloat(coord.toFixed(7)));
                        })
                    }
                    var parcelle = {
                        id: row.data[1],
                        // c: parseInt(row.data[4]), //contenance
                        s: superficie || parseInt(row.data[4]),
                        p: perimetre,
                        // com: centerOfMass,
                        bb: bbox_optim,
                        coords: geom?.geometry?.coordinates || null,
                    }
                    data_parcelle[row.data[3]][arrond][section].push(parcelle);
                    nb_parcelle++;
                    // Add data communes
                    // if (bbox_optim) {
                    //     if (data_commune[row.data[3]].sections[section].bbox.length === 0) { data_commune[row.data[3]].sections[section].bbox = bbox_optim }
                    //     else if (data_commune[row.data[3]].sections[section].bbox[0] > bbox_optim[0]) { data_commune[row.data[3]].sections[section].bbox[0] = bbox_optim[0] }
                    //     else if (data_commune[row.data[3]].sections[section].bbox[1] > bbox_optim[1]) { data_commune[row.data[3]].sections[section].bbox[1] = bbox_optim[1] }
                    //     else if (data_commune[row.data[3]].sections[section].bbox[2] < bbox_optim[2]) { data_commune[row.data[3]].sections[section].bbox[2] = bbox_optim[2] }
                    //     else if (data_commune[row.data[3]].sections[section].bbox[3] < bbox_optim[3]) { data_commune[row.data[3]].sections[section].bbox[3] = bbox_optim[3] }
                    // }
                    // if (geom) {
                    //     data_commune[row.data[3]].sections[section].lands.push(geom);
                    // }
                    // Add data filtres
                    data_filtre[row.data[3]].land_area = {};
                    data_filtre[row.data[3]].land_perimeter = {};
                }
                count++;
            },
            complete: function () {
                // Get sections near
                // var communes_keys = Object.keys(data_commune);
                // communes_keys.forEach(commune_key => {
                //     var sections_keys = Object.keys(data_commune[commune_key].sections);
                //     sections_keys.forEach(section_key => {
                //         // var section_bbox_polygon = turf.bboxPolygon(data_commune[commune_key].sections[section_key].bbox);
                //         // var section_bbox_polygon = turf.buffer(data_commune[commune_key].sections[section_key].union, 0.005, { steps: 2 });
                //         var section_poly = turf.buffer(turf.combine(turf.featureCollection(data_commune[commune_key].sections[section_key].lands)).features[0], 0.05, { steps: 2 });
                //         sections_keys.forEach(section_key2 => {
                //             if (section_key !== section_key2) {
                //                 var section2_poly = turf.combine(turf.featureCollection(data_commune[commune_key].sections[section_key2].lands)).features[0];
                //                 // var section2_bbox_polygon = turf.bboxPolygon(data_commune[commune_key].sections[section_key2].bbox);
                //                 // var section2_bbox_polygon = data_commune[commune_key].sections[section_key2].union;
                //                 var intersection = turf.intersect(section_poly, section2_poly);
                //                 if (intersection) { data_commune[commune_key].sections[section_key].near.push(section_key2) }
                //             }
                //         })
                //     })
                // })

                // Results
                console.log("All done!", count);
                console.log("COMMUNES", commune_list);
                console.log("DATA PARCELLES", data_parcelle);
                console.log("DATA COMMUNES", data_commune);
                console.log("DATA FILTERS", data_filtre);

                // SAVE INTO FILE
                // download_json_file(data_parcelle, "parcelles_list");
            }
        });
    }
    else if (file?.name === "batiment_groupe.csv") {
        console.log("PARSE BAT...");
        data_batiment = {};
        bat_list_h1 = [];

        var count = 0;
        Papa.parse(file, {
            delimiter: ";",
            step: function (row) {
                if (count > 0 && row.data.length > 1) {
                    var bat_id = row.data[1];
                    if (bat_id) {
                        var bat_id_h1 = bat_id.substring(0, 9);
                        var bat_id_h2 = bat_id.substring(0, 10);
                        var bat_id_h3 = bat_id.substring(0, 11);
                        // Create object H1 level
                        if (!bat_list_h1.includes(bat_id_h1)) {
                            bat_list_h1.push(bat_id_h1);
                            data_batiment[bat_id_h1] = {};
                        }
                        // Create object H2 level
                        var bat_list_h2 = Object.keys(data_batiment[bat_id_h1]);
                        if (!bat_list_h2.includes(bat_id_h2)) {
                            data_batiment[bat_id_h1][bat_id_h2] = {};
                        }
                        // Create object H3 level
                        var bat_list_h3 = Object.keys(data_batiment[bat_id_h1][bat_id_h2]);
                        if (!bat_list_h3.includes(bat_id_h3)) {
                            data_batiment[bat_id_h1][bat_id_h2][bat_id_h3] = {};
                        }
                        // Create object
                        var bat_list = Object.keys(data_batiment[bat_id_h1][bat_id_h2][bat_id_h3]);
                        if (!bat_list.includes(bat_id)) {
                            data_batiment[bat_id_h1][bat_id_h2][bat_id_h3][bat_id] = {};
                        }
                        // Get data
                        var geom = bdnb_get_geometry_from_string(row.data[0]);
                        var emp = geom ? Math.round(turf.area(geom)) : parseInt(row.data[3]);
                        // Add data to object
                        data_batiment[bat_id_h1][bat_id_h2][bat_id_h3][bat_id].coords = geom?.geometry?.coordinates || null;
                        data_batiment[bat_id_h1][bat_id_h2][bat_id_h3][bat_id].s = emp;
                        // Count bat
                        nb_bat++;
                    }
                }
                count++;
            },
            complete: function () {
                console.log("All done!", count);
                console.log(data_batiment);

                console.log("NEXT STEP --> Import : batiment_groupe_bdtopo_bat.csv");

                // SAVE INTO FILE
                // download_json_file(data_batiment, "batiments_list");
            }
        });
    }
    else if (file?.name === "batiment_groupe_bdtopo_bat.csv" && bat_list_h1.length > 0) {
        console.log("PARSE BAT BDTOPO...");
        var nb_bat_i = 0;
        var nb_bat_nf = 0;

        var count = 0;
        Papa.parse(file, {
            delimiter: ";",
            step: function (row) {
                if (count > 0 && row.data.length > 1) {
                    var bat_id = row.data[0];
                    if (bat_id) {
                        var bat_id_h1 = bat_id.substring(0, 9);
                        var bat_id_h2 = bat_id.substring(0, 10);
                        var bat_id_h3 = bat_id.substring(0, 11);
                        // Check if bat id exists
                        var bat_found = false;
                        if (bat_list_h1.includes(bat_id_h1)) {
                            var bat_list_h2 = Object.keys(data_batiment[bat_id_h1]);
                            if (bat_list_h2.includes(bat_id_h2)) {
                                var bat_list_h3 = Object.keys(data_batiment[bat_id_h1][bat_id_h2]);
                                if (bat_list_h3.includes(bat_id_h3)) {
                                    var bat_list = Object.keys(data_batiment[bat_id_h1][bat_id_h2][bat_id_h3]);
                                    if (bat_list.includes(bat_id)) {
                                        // Add data to object
                                        data_batiment[bat_id_h1][bat_id_h2][bat_id_h3][bat_id].h = parseInt(row.data[6]);
                                        data_batiment[bat_id_h1][bat_id_h2][bat_id_h3][bat_id].h_max = parseInt(row.data[7]);
                                        data_batiment[bat_id_h1][bat_id_h2][bat_id_h3][bat_id].alti = parseInt(row.data[8]);
                                        // Count
                                        nb_bat_i++;
                                        bat_found = true;
                                        if (nb_bat_i === 2) { console.log(bat_id) }
                                    }
                                }
                            }
                        }
                        if (!bat_found) { nb_bat_nf++ }
                    }
                }
                count++;
            },
            complete: function () {
                console.log("All done!", count, nb_bat_i, nb_bat_nf);
                console.log(data_batiment);

                console.log("NEXT STEP --> Import : batiment_groupe_ffo_bat.csv");

            }
        });
    }
    else if (file?.name === "batiment_groupe_ffo_bat.csv" && bat_list_h1.length > 0) {
        console.log("PARSE BAT BDTOPO...");
        var nb_bat_i = 0;
        var nb_bat_nf = 0;

        var count = 0;
        Papa.parse(file, {
            delimiter: ";",
            step: function (row) {
                if (count > 0 && row.data.length > 1) {
                    var bat_id = row.data[0];
                    if (bat_id) {
                        var bat_id_h1 = bat_id.substring(0, 9);
                        var bat_id_h2 = bat_id.substring(0, 10);
                        var bat_id_h3 = bat_id.substring(0, 11);
                        // Check if bat id exists
                        var bat_found = false;
                        if (bat_list_h1.includes(bat_id_h1)) {
                            var bat_list_h2 = Object.keys(data_batiment[bat_id_h1]);
                            if (bat_list_h2.includes(bat_id_h2)) {
                                var bat_list_h3 = Object.keys(data_batiment[bat_id_h1][bat_id_h2]);
                                if (bat_list_h3.includes(bat_id_h3)) {
                                    var bat_list = Object.keys(data_batiment[bat_id_h1][bat_id_h2][bat_id_h3]);
                                    if (bat_list.includes(bat_id)) {
                                        // Add data to object
                                        data_batiment[bat_id_h1][bat_id_h2][bat_id_h3][bat_id].niv = parseInt(row.data[2]);
                                        data_batiment[bat_id_h1][bat_id_h2][bat_id_h3][bat_id].a_const = parseInt(row.data[3]);
                                        data_batiment[bat_id_h1][bat_id_h2][bat_id_h3][bat_id].nb_loc = parseInt(row.data[7]);
                                        // Count
                                        nb_bat_i++;
                                        bat_found = true;
                                        if (nb_bat_i === 2) { console.log(bat_id) }
                                    }
                                }
                            }
                        }
                        if (!bat_found) { nb_bat_nf++ }
                    }
                }
                count++;
            },
            complete: function () {
                console.log("All done!", count, nb_bat_i, nb_bat_nf);
                console.log(data_batiment);

                console.log("NEXT STEP --> Import : batiment_groupe_dpe_statistique_logement.csv");

            }
        });
    }
    else if (file?.name === "batiment_groupe_dpe_statistique_logement.csv" && bat_list_h1.length > 0) {
        console.log("PARSE BAT BDTOPO...");
        var nb_bat_i = 0;
        var nb_bat_nf = 0;

        var count = 0;
        Papa.parse(file, {
            delimiter: ";",
            step: function (row) {
                if (count > 0 && row.data.length > 1) {
                    var bat_id = row.data[0];
                    if (bat_id) {
                        var bat_id_h1 = bat_id.substring(0, 9);
                        var bat_id_h2 = bat_id.substring(0, 10);
                        var bat_id_h3 = bat_id.substring(0, 11);
                        // Check if bat id exists
                        var bat_found = false;
                        if (bat_list_h1.includes(bat_id_h1)) {
                            var bat_list_h2 = Object.keys(data_batiment[bat_id_h1]);
                            if (bat_list_h2.includes(bat_id_h2)) {
                                var bat_list_h3 = Object.keys(data_batiment[bat_id_h1][bat_id_h2]);
                                if (bat_list_h3.includes(bat_id_h3)) {
                                    var bat_list = Object.keys(data_batiment[bat_id_h1][bat_id_h2][bat_id_h3]);
                                    if (bat_list.includes(bat_id)) {
                                        var dpe = [];
                                        dpe.push(parseInt(row.data[2]));
                                        dpe.push(parseInt(row.data[3]));
                                        dpe.push(parseInt(row.data[4]));
                                        dpe.push(parseInt(row.data[5]));
                                        dpe.push(parseInt(row.data[6]));
                                        dpe.push(parseInt(row.data[7]));
                                        dpe.push(parseInt(row.data[8]));
                                        // Add data to object
                                        data_batiment[bat_id_h1][bat_id_h2][bat_id_h3][bat_id].dpe = dpe;
                                        // Count
                                        nb_bat_i++;
                                        bat_found = true;
                                        if (nb_bat_i === 2) { console.log(bat_id) }
                                    }
                                }
                            }
                        }
                        if (!bat_found) { nb_bat_nf++ }
                    }
                }
                count++;
            },
            complete: function () {
                console.log("All done!", count, nb_bat_i, nb_bat_nf);
                console.log(data_batiment);

                console.log("NEXT STEP --> Import : batiment_groupe_dvf_open_statistique.csv");

            }
        });
    }


    else if (file?.name === "rel_batiment_groupe_parcelle.csv") {
        console.log("PARSE PARCELLE...");

        // Papa.parse(file, {
        //     delimiter: ";",
        //     complete: function (results) {
        //         console.log("Finished:", results);
        //         if (results.data.length > 0) {
        //             results.data.forEach((line, line_index) => {
        //                 if (line_index > 0) {
        //                     var city_code = line[5];
        //                     // Create city
        //                     if (!city_list.includes(city_code)) {
        //                         city_list.push(city_code);
        //                         data_by_city[city_code] = {
        //                             buildings: {},
        //                         };
        //                     }
        //                     // Add building
        //                     var building_id = line[1];
        //                     var buildings_keys = Object.keys(data_by_city[city_code].buildings);
        //                     if (!buildings_keys.includes(building_id)) {
        //                         data_by_city[city_code][building_id] = {
        //                             geom: line[0],
        //                             area: line[3],
        //                         };
        //                     }
        //                     else {
        //                         console.log("DOUBLE", line_index);
        //                     }
        //                 }
        //             })
        //         }
        //         console.log(data_by_city);
        //     }
        // });

    }
}